export default __webpack_public_path__ + "static/media/engagement.405c00f0.svg";